import { Session } from "svelte-session-manager";
import { fetchWrapper } from "./fetchWrapper.js";

export async function fetchWithSession(url, options = {}) {
  const session = new Session(localStorage);
  const headers = {
    ...options.headers,
    ...session.authorizationHeader,
  };
  return fetchWrapper(url, { ...options, headers });
}
